import React from 'react';
import { AnimatedSection } from './ui/AnimatedSection';
export function Mechanism() {
  return <div className="bg-brand-green text-white py-24 px-6" data-id="element-103">
      <AnimatedSection className="max-w-4xl mx-auto text-center" data-id="element-104">
        <h2 className="text-3xl md:text-4xl font-bold mb-8 text-brand-cream" data-id="element-105">
          El "Método de Sustitución Directa"
        </h2>
        <div className="space-y-6 text-lg md:text-xl text-brand-cream/90" data-id="element-106">
          <p data-id="element-107">
            No vamos a prohibir todo lo que te gusta. Vamos a identificar los 3
            "disparadores de incendio" en tu despensa actual y cambiarlos por
            "extintores" naturales que se venden por menos de $2 en el pasillo
            de congelados y especias.
          </p>
          <p className="font-medium text-white text-2xl py-4" data-id="element-108">
            Es una estrategia de nutrición diseñada específicamente para la
            biología de la mujer mayor.
          </p>
        </div>
      </AnimatedSection>
    </div>;
}